export const localeDateName = 'en-US';
export const timeOptions = {
  hour: 'numeric',
  minute: '2-digit',
  hour12: true,
};
export const dateOptions = {
  month: 'long',
  day: '2-digit',
  year: 'numeric',
};
